import { produce } from "../libs/immer";
import { useEffect } from "../libs/react";
import useEscapeKey from "../utils/useEscapeKey/useEscapeKey";
import { getUserType } from "./components/PaymentContainer/components/PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/utils";
import { TOPUP_WIDGET_OPEN_QUERY_PARAMETER } from "./dependencies/checkUrl/constants";
import { clearParams, getUrlParams } from "./dependencies/checkUrl/utils";
import { UserAccountInfo } from "./dependencies/getUserAccountInfo/UserAccountInfo";
export var useSetOpenLogic = function useSetOpenLogic(state, setState, props) {
  useEffect(function () {
    if (props.isOpen) {
      setState(produce(function (draft) {
        draft.isOpen = true;
      }));
    }
  }, [props.isOpen]);
  useEffect(function () {
    if (!state.isOpen) {
      var _props$onClose;
      props.setIsOpen(false);
      (_props$onClose = props.onClose) === null || _props$onClose === void 0 || _props$onClose.call(props);
    }
  }, [state.isOpen]);
  useEffect(function () {
    var isOpen = Object.keys(getUrlParams()).includes(TOPUP_WIDGET_OPEN_QUERY_PARAMETER);
    if (isOpen) {
      clearParams([TOPUP_WIDGET_OPEN_QUERY_PARAMETER]);
      props.setIsOpen(true);
    }
  }, []);
};
export var useEscapeLogic = function useEscapeLogic(setState) {
  useEscapeKey(function () {
    setState(produce(function (draft) {
      if (draft.statusPopup) {
        delete draft.statusPopup;
        return;
      }
      if (draft.scenario) {
        delete draft.scenario;
        return;
      }
      draft.isOpen = false;
    }));
  });
};
export var useSetUserDataLogic = function useSetUserDataLogic(props, setState) {
  useEffect(function () {
    var _ref, _props$userInfo$ctn, _props$userInfo, _props$userInfo2, _props$prefilledAccou;
    var legacyAccountNumber = (_ref = (_props$userInfo$ctn = (_props$userInfo = props.userInfo) === null || _props$userInfo === void 0 ? void 0 : _props$userInfo.ctn) !== null && _props$userInfo$ctn !== void 0 ? _props$userInfo$ctn : (_props$userInfo2 = props.userInfo) === null || _props$userInfo2 === void 0 ? void 0 : _props$userInfo2.fttb) !== null && _ref !== void 0 ? _ref : undefined;
    var accountNumber = props.accountNumber || props.isAuth && legacyAccountNumber;
    var prefilledNumber = (_props$prefilledAccou = props.prefilledAccountNumber) !== null && _props$prefilledAccou !== void 0 ? _props$prefilledAccou : legacyAccountNumber;
    if (accountNumber) {
      UserAccountInfo.getInstance().initialize({
        accountNumber: accountNumber,
        userType: getUserType(accountNumber)
      }).catch(console.error);
    }
    if (prefilledNumber) {
      setState(produce(function (draft) {
        draft.phoneInput.value = prefilledNumber;
      }));
    }
  }, [props.userInfo, props.accountNumber, props.isAuth, props.prefilledAccountNumber]);
};